var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalonSocialOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Salon_Social",
    "data-name": "Salon Social",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.62,
    height: 53.622,
    viewBox: "0 0 53.62 53.622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #006533;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-1",
    d: "M53.631,10.211a2.358,2.358,0,0,0-2.356-2.357H40.958V4.578A2.357,2.357,0,0,0,40.172,0H13.466a2.357,2.357,0,0,0-.785,4.579V7.855H2.363a2.357,2.357,0,0,0-.786,4.578V48.126a.786.786,0,0,0,.786.783H17.392l-4.4,3.3a.786.786,0,0,0,.471,1.414H40.171a.786.786,0,0,0,.472-1.414l-4.4-3.3H51.275a.786.786,0,0,0,.783-.783h0V12.432a2.357,2.357,0,0,0,1.572-2.22ZM40.959,12.567h9.53V39.273H40.958Zm-27.494-11H40.172a.786.786,0,1,1,0,1.571H16.607a.786.786,0,0,0,0,1.571H39.39V47.337H37.816v-16.7a.786.786,0,0,0-.786-.789H16.607a.786.786,0,0,0-.785.786V47.345H14.251V3.924a.786.786,0,0,0-.786-.786h0a.786.786,0,0,1,0-1.571ZM27.6,47.345V37.7h5.5v9.636Zm-7.07,0V37.7h5.5v9.636ZM33.888,36.139H19.75a.786.786,0,0,0-.786.786h0v10.42H17.393V31.419H36.246V47.338H34.674V36.918a.786.786,0,0,0-.786-.786ZM12.68,12.567V39.273H3.15V12.567ZM2.363,9.425H12.68V11H2.363a.786.786,0,1,1,0-1.571ZM3.15,40.844H12.68v6.495H3.15ZM37.814,52.051H15.822l4.19-3.142H33.627Zm3.142-4.712V40.844h9.53v6.495ZM51.275,11H40.956V9.425H51.275a.786.786,0,0,1,0,1.571Z",
    transform: "translate(-0.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-1",
    d: "M33.213,108.292h4.82a.786.786,0,0,0,.786-.786v-9.43a.786.786,0,0,0-.786-.786h-4.82a.786.786,0,0,0-.785.786h0V107.5a.786.786,0,0,0,.785.79ZM34,98.866h3.246v7.854H34Z",
    transform: "translate(-27.718 -83.152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-1",
    d: "M298.2,97.29h-4.819a.786.786,0,0,0-.784.786h0V107.5a.786.786,0,0,0,.784.79H298.2a.786.786,0,0,0,.784-.786v-9.43A.786.786,0,0,0,298.2,97.29Zm-.786,9.427h-3.246V98.87h3.246Z",
    transform: "translate(-250.082 -83.152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-1",
    d: "M33.213,194.776h4.82a.786.786,0,0,0,.786-.785v-9.427a.786.786,0,0,0-.786-.785h-4.82a.785.785,0,0,0-.785.785v9.427A.785.785,0,0,0,33.213,194.776ZM34,185.351h3.246V193.2H34Z",
    transform: "translate(-27.718 -157.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-1",
    d: "M298.2,183.78h-4.819a.785.785,0,0,0-.784.785v9.427a.785.785,0,0,0,.784.785H298.2a.784.784,0,0,0,.784-.785v-9.427A.785.785,0,0,0,298.2,183.78Zm-.786,9.425h-3.246v-7.847h3.246Z",
    transform: "translate(-250.082 -157.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-1",
    d: "M126.763,74.48h-4.819a.786.786,0,0,0-.785.786h0v9.425a.786.786,0,0,0,.785.786h4.819a.786.786,0,0,0,.785-.786V75.266A.786.786,0,0,0,126.763,74.48Zm-.786,9.427h-3.242V76.06h3.246Z",
    transform: "translate(-103.556 -63.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-1",
    d: "M211.078,75.93h-4.811a.786.786,0,0,0-.786.783h0V86.14a.786.786,0,0,0,.786.786h4.811a.786.786,0,0,0,.784-.786V76.713A.784.784,0,0,0,211.078,75.93Zm-.786,9.425h-3.24V77.508H210.3Z",
    transform: "translate(-175.623 -64.896)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalonSocialOrange);
export default __webpack_public_path__ + "static/media/Salon Social_orange.c3a5ef51fa38c98ecadd8d13980551b8.svg";
export { ForwardRef as ReactComponent };